import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SecondaryNav } from '@feathr/components';
import { useNavigation } from '@feathr/extender/state';

import EventNav from '../PrimaryNav/EventNav';

interface IProjectsSecondaryNavProps {
  className?: string;
}

function ProjectsSecondaryNav({ className }: Readonly<IProjectsSecondaryNavProps>): JSX.Element {
  const { t } = useTranslation();
  const { setActiveSecondaryNav, scrollableRef, toggleMinimized } = useNavigation();

  const handleBack = (): void => {
    setActiveSecondaryNav(null);
  };

  const handleMinimize = (): void => {
    toggleMinimized();
  };

  return (
    <SecondaryNav
      className={className}
      onBack={handleBack}
      onMinimize={handleMinimize}
      scrollableRef={scrollableRef}
      title={t('Projects')}
    >
      <EventNav indented={false} />
    </SecondaryNav>
  );
}

export default ProjectsSecondaryNav;
